import React from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useTranslation } from "react-i18next";

const LogoutModal = (props) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={props?.open}
      closeOnEsc={false}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      center
      classNames={{ modal: "modal-own", root: "modal-own-wrapper" }}
    >
      <div className="video-player-wrapper px-2 text-center">
        <p className=" primary-color py-3">{t("common.logoutModal.message")}</p>
        <div>
          <button
            className="btnCancel footer-width mx-2 my-2"
            onClick={() => {
              // eslint-disable-next-line
              props?.closeModal(false);
            }}
          >
            {t("common.logoutModal.no")}
          </button>
          <button
            className="btnFooter footer-width mx-2 my-2"
            onClick={() => {
              // eslint-disable-next-line
              props?.closeModal(true);
            }}
          >
            {t("common.logoutModal.yes")}
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default LogoutModal;
